<template>
  <div>
    <div class="main">
      <!-- logo -->
      <div>
        <!-- 轮播 -->
        <div class="md-example-child-swiper md-example-child-swiper-0">
          <md-swiper @before-change="beforeChange" @after-change="afterChange" ref="swiper" :is-prevent="false"
            :useNative-driver="false">
            <md-swiper-item :key="$index" v-for="(item, $index) in simple">
              <div class="banner-item">
                <img :src="item" class="swiperimg"/>
              </div>
            </md-swiper-item>
          </md-swiper>
        </div>
      </div>

      <md-notice-bar class="notice" mode="closable" icon="volumn" scrollable>
        {{ noticetitle }}
        <md-icon slot="right" name="warn" @click="get_homenotice()"></md-icon>
      </md-notice-bar>

      <md-field class="introduction">
        <md-cell-item title="Total Assets" :addon="$store.state.userinfo.itoken"/>
        <md-cell-item title="IToken">
          <span class="tipchildren">
              1 Rs = 1 I Token, 1 USDT ≈ {{ exchangerate }} I Token
          </span>
          <!-- <template #children class="tipgroup"></template> -->
          
          <img src="/static/icon/i.png" class="holder" slot="left" />
          <div slot="right">
            <md-button type="primary" size="small" @click="go_buy" style="padding: 0 10px;"> Buy </md-button>
          </div>
        </md-cell-item>
      </md-field>
      
      <md-tab-bar class="md-bar" v-model="current" :items="items" :has-ink="false" @change="choose_btn">
        <template slot="item" slot-scope="{ item }">
          <div class="custom-item" style="margin: 0.1rem 0rem !important">
            <div class="icon">
              <iconimg :name="item.icon" size="xl"></iconimg>
            </div>
            <div class="text">
              <span v-text="item.label"></span>
            </div>
          </div>
        </template>
      </md-tab-bar>
      
      <!-- chart -->
      <!-- <md-field class="introduction">
        <md-cell-item title="Itoken 24 Hours quote" />
        <div id="chart-main" class="chart" style="width: 100%; height: 220px;"></div>
      </md-field> -->
      
      <!-- News -->
      <md-field>
        <md-cell-item title="TT Notice" addon="More" arrow style="margin-bottom: 10px;">
          <p slot="right" @click="go_news">More</p>
        </md-cell-item>
        <md-cell-item :title="news.name" :brief="news.ctime" v-for="news in newlist" v-bind:key="news.id" @click="show_children(news.id)" />
      </md-field>
    </div>
    <navbar></navbar>
    <notice :title="noticetitle" :content="notice_content" :open="noticeopen"></notice>
  </div>
</template>

<script>
import navbar from '@/components/navbar.vue';
import notice from '@/components/notice.vue';
import card from '@/components/card.vue';
import iconimg from '@/components/iconimg';
import * as echarts from 'echarts';
import { TabBar, Swiper, SwiperItem } from 'mand-mobile';
import { getnewsCodedetail, getcwexchangerate, getcwinviterank, getcwprofitrank, getnewslist, organization } from '@/request/api';

export default {
  name: 'Home',
  components: {
    navbar,
    [TabBar.name]: TabBar,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
    notice,
    card,
    iconimg
  },
  data() {
    return {
      simple: [],
      noticeopen: false,
      noticetitle: "Notice",
      notice_content: "",
      current: 0,
      exchangerate: 0,
      logo: [
        {name: 0, label: 'logo', icon: 'logo'},
      ],
      items: [
        {name: 0, label: 'Tutorial', icon: 'video'},
        {name: 1, label: 'Sell', icon: 'registersuccess'},
        {name: 2, label: 'Kyc Manage', icon: 'kyc'},
        {name: 3, label: 'TT channel', icon: 'telegram'}
      ],
      inviterank: [],
      profitrank: [],
      newlist: []
    }
  },
  created() {
    this.$store.dispatch('asyncupdatesiteconfig');
    this.$store.dispatch('asyncupdateuserinfo');
    this.get_homecarousel();
    this.get_homenotice();
    this.get_cwexchangerate();
    this.get_newlist();
  },
  updated() {
    if (this.noticeopen) {
      this.noticeopen = false;
    }
  },
  mounted() {
    this.make_chart();
    window.triggerSwiper3 = () => {
      this.goto();
    }
  },
  methods: {
    setValue(id, value) {
      document.querySelector(id) && (document.querySelector(id).innerHTML = value)
    },
    beforeChange(from, to) {
      this.setValue('#valueSwiper10', from)
      this.setValue('#valueSwiper11', to)
    },
    afterChange(from, to) {
      this.setValue('#valueSwiper12', from)
      this.setValue('#valueSwiper13', to)
    },
    goto() {
      this.$refs.swiper.goto(2)
    },
    make_chart(){
      var myChart = echarts.init(document.getElementById('chart-main'));
      myChart.setOption({
        // title: "IToken",
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['0:00', '04:00', '08:00', '12:00', '16:00', '23:59']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [0.907, 0.984, 0.921, 0.999, 1.019, 0.951],
            type: 'line',
            areaStyle: {}
          }
        ]
      });
    },
    choose_btn(item, index, prevIndex){
      console.log(item, index, prevIndex);
      switch(index) {
        case 0:
          this.go_tutorial();
          break;
        case 1:
          this.go_sell();
          break;
        case 2:
          this.go_kyc();
          break;
        case 3:
          this.go_tg_channel();
          break;
        default:
          break;
      }
    },
    get_newlist() {
      getnewslist({
        organization: organization
      }).then(res => {
        if (res.code === 200) {
          let myArray = res.data.result;
          for (let i = 0; i < myArray.length; i++) {
            if (i <= 3) {
              this.newlist.push(myArray[i])
            }
          }
        }
      })
    },
    get_getcwinviterank() {
      getcwinviterank().then(res => {
        if (res.code === 200) {
          this.inviterank = res.data;
        }
      })
    },
    get_getcwprofitrank() {
      getcwprofitrank().then(res => {
        if (res.code === 200) {
          this.profitrank = res.data;
        }
      })
    },
    get_cwexchangerate() {
      getcwexchangerate().then(res => {
        this.exchangerate = res.data.exchangerate;
      })
    },
    go_tutorial() {
      this.$router.push('/tutorial')
    },
    go_news() {
      this.$router.push('/news')
    },
    show_children(id) {
      this.$router.push("/newdetail/" + id);
    },
    go_buy() {
      this.$router.push('/transaction')
    },
    go_kyc() {
      this.$router.push('/kycpartner')
    },
    go_sell() {
      this.$router.push('/sell')
    },
    go_cs() {
      this.$router.push('/customerservice')
    },
    go_tg_channel() {
      window.location.href = this.$store.state.siteconfig.tg_channel_link;
    },
    get_homenotice() {
      getnewsCodedetail(organization + "notice").then(res => {
        if (res.code === 200) {
          this.noticeopen = true;
          this.noticetitle = res.data.name;
          this.notice_content = res.data.content;
        }
      })
    },
    get_homecarousel() {
      getnewsCodedetail(organization + "homecarousel").then(res => {
        if (res.code === 200) {
          this.simple = this.extract_src(res.data.content);
          console.log(res);
        }
      });
    },
    extract_src(content) {
      let imgReg = /<img.*?(?:>|\/>)/gi
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i
      let arr = content.match(imgReg)
      let srcArr = []
      for (let i = 0; i < arr.length; i++) {
        let src = arr[i].match(srcReg)
        srcArr.push(src[1])
      }
      console.log(srcArr);
      return srcArr;
    },

    setValue(id, value) {
      document.querySelector(id) && (document.querySelector(id).innerHTML = value)
    },
    beforeChange(from, to) {
      this.setValue('#valueSwiper0', from)
      this.setValue('#valueSwiper1', to)
    },
    afterChange(from, to) {
      this.setValue('#valueSwiper2', from)
      this.setValue('#valueSwiper3', to)
    },
    fn(index) {
      this.setValue('#valueSwiper4', index)
    },
    goto() {
      this.$refs.swiper.goto(2)
    },
    play() {
      this.$refs.swiper.play()
    },
    stop() {
      this.$refs.swiper.stop()
    },
    onSwiperChange(from, to) {
      this.current = to
    },
    onTabChange(item, index) {
      this.$refs.swiper.goto(index)
    },
  },
}
</script>

<style scoped>
.notice{
  margin-top: 0.2rem;
}
.introduction{
  background-color: #FFF;
  margin: 0.2rem 0;
  padding: 0.2rem;
}
.md-bar{
  margin: 0.3rem 0;
}
.chart {
    width: 100%;
    height: 3.2rem;
}
.news{
  margin: 0.3rem 0;
}
.md-example-child-swiper-2{
  height: 250px;
}
.md-example-child-swiper-2 .banner-item{
    float: left;
    width: 100%;
    height: 100%;
    line-height: 250px;
    text-align: center;
    font-size: 28px;
    color: #FFF;
    box-align: center;
    align-items: center;
    box-pack: center;
    justify-content: center;
    text-decoration-line: none;
  }

.rank-list {
  height: 200px;
  overflow: scroll;
}

.profit-table {
  width: 100%;
  text-align: center;
}

.profit-table tr {
  height: 0.63rem;
  color: black;
}

.telegrambtn {
  background: #f0b90b;
  color: black;
}

.telegrambtn img {
  width: 0.65rem;
  margin-right: 0.3rem;
}

.purchase-btns {
  display: flex;
  justify-content: space-around;
  margin-bottom: 0.2rem;
}

.purchase-btns-btn {
  height: 0.75rem;
  width: 3rem;
}

.tab{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.swiperimg {
  width: 100%;
  height: 100%;
}

.md-example-child-tab-bar-6 .md-swiper {
  background: #FFF;
}

.md-example-child-tab-bar-6 .md-swiper .md-swiper-item {
  padding: 20px;
  box-sizing: border-box;
  font-size: 24px;
  line-height: 1.5;
  color: #666;
}

.md-example-child-swiper-0 {
  height: 4.5rem;
}

.md-example-child-swiper-0 .banner-item {
  float: left;
  width: 100%;
  height: 100%;
  line-height: 250px;
  text-align: center;
  font-size: 28px;
  color: #FFF;
  box-align: center;
  align-items: center;
  box-pack: center;
  justify-content: center;
  text-decoration-line: none;
}

.md-example-child-amount {
  text-align: center;
  color: #666;
}

.md-example-child-amount .p {
  font-size: 50px;
}

.md-example-child-amount .p .describe {
  font-size: 18px;
}

.holder {
  margin: 10px auto;
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #e6e6e6;
}

.title {
  font-size: 0.4rem;
  margin: 5px;
}

.btngroup {
  margin: 0.2rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.btngroup .btnitem {
  text-align: center;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: calc(90% / 3);
  height: calc(90% / 3);
  border-radius: 20px;
  box-shadow: 0 8px 12px #ebedf0;
  overflow: auto;
}

.wrapper {
  height: 24rem;
}

.main>>>.md-cell-item-children {
  display: flex;
  flex-direction: column;
  padding-top: unset;
}

.main>>>.md-cell-item-body {
  padding-bottom: unset;
}

.tipchildren {
  color: #858b9c;
  font-size: 0.24rem;
  line-height: 1.4;
  margin-top: 0.08rem;
}

.main {
  flex: 1;
  height: 1200px;
  background-color: #F7F6FB;
}
.custom-item {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}

.md-bar {
  padding-left: 0rem !important;
  padding-right: 0rem !important;
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue